import { render, staticRenderFns } from "./VideoDetailInfo.vue?vue&type=template&id=51876048&"
import script from "./VideoDetailInfo.vue?vue&type=script&lang=js&"
export * from "./VideoDetailInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports